
/* eslint-disable @typescript-eslint/camelcase */
import {
  ErrorMessageEntities,
  ModalMessageEntities,
  OptionsClass
} from "@/domain/entities/MainApp";
import {
  PusatResolusiV2CodeResponseCreate,
  PusatResolusiV2Action,
  PusatResolusiSTT,
  CategoryPusatResolusi
} from "@/domain/entities/PusatResolusiV2";
import { Vue, Options } from "vue-class-component";
import {
  PusatResolusiV2Detail,
  PusatResolusiV2Type,
  TicketPusatResolusiDetail
} from "@/domain/entities/PusatResolusiV2";
import { PusatResolusiV2Controller } from "@/app/ui/controllers/PusatResolusiV2Controller";
import { CheckTicketPusatResolusiRequest } from "@/data/payload/api/PusatResolusiV2ApiRequest";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import HowToReportCard from "./how-to-report-card.vue";
import cardSTT from "./cardSTT.vue";
import {
  INTERNET_ERROR,
  parsingErrorResponse
} from "@/app/infrastructures/misc/Utils";
import CsInfo from "./cs-info.vue";
import _ from "lodash";

@Options({
  components: {
    HowToReportCard,
    cardSTT,
    CsInfo
  }
})
export default class PusatResolusiV2Create extends Vue {
  // initial data
  onBack(isFromModal = false) {
    this.$router.push(
      isFromModal ? "/pusat-resolusi-v2/tiket-saya" : "/pusat-resolusi-v2"
    );
    this.form = new PusatResolusiV2Detail();
    this.ticketDetail = new TicketPusatResolusiDetail();
    this.sttShipmentDetail = new TicketPusatResolusiDetail();
    this.sttIssueCategory = "";
    this.listCategory = [];
    this.sttOrShipmentNoInLastSttOrShipmentList = false;
    this.onResetAllAttachments();
    this.showResponseCreate = false;
  }

  get getPusatResolusiV2Action() {
    return PusatResolusiV2Action;
  }
  get getPusatResolusiV2Type() {
    return PusatResolusiV2Type;
  }
  form = new PusatResolusiV2Detail();
  typeList: OptionsClass[] = [
    new OptionsClass({
      name: "Pengiriman & bantuan",
      value: PusatResolusiV2Type.shippingService
    }),
    new OptionsClass({
      name: "Sistem & banding pinalti",
      value: PusatResolusiV2Type.systemPenalty
    })
  ];

  mounted() {
    this.form.sttNoShipmentNo = (this.$route.query.sttNo as string) || "";
  }

  // type
  onChangeType(item: OptionsClass) {
    if (this.form.type !== item.value) {
      this.form = new PusatResolusiV2Detail({
        type: item.value
      });
      this.sttShipmentDetail = new TicketPusatResolusiDetail();
      this.onResetAllAttachments();
      this.sttOrShipmentNoInLastSttOrShipmentList = false;
    }
  }

  // stt or shipment
  isTooltipCheck = false;
  toggleTooltipCheck(event: any) {
    this.isTooltipCheck = !this.isTooltipCheck;

    const refs: any = this.$refs;
    refs?.["opTooltip"]?.toggle(event);
  }
  sttOrShipmentNoInLastSttOrShipmentList = false;
  isChangeSttOrShipmentNo = false;
  onChangeSttNoShipmentNo() {
    this.isChangeSttOrShipmentNo = true;
    this.sttShipmentDetail = new TicketPusatResolusiDetail();
    this.sttIssueCategory = "";
    this.listCategory = [];
    this.form = new PusatResolusiV2Detail({
      ...this.form,
      sttNoShipmentNo: this.form.sttNoShipmentNo,
      category: new OptionsClass()
    });

    const alreadyInList = !!PusatResolusiV2Controller.lastSttOrShipmentNoList.find(
      (e) => e.sttNo?.toLowerCase() === this.form.sttNoShipmentNo?.toLowerCase()
    );
    if (alreadyInList) {
      this.sttOrShipmentNoInLastSttOrShipmentList = true;
      return;
    }

    if (!this.form.sttNoShipmentNo) {
      this.sttOrShipmentNoInLastSttOrShipmentList = false;
      return;
    }
  }
  async onSelectStt(item: PusatResolusiSTT) {
    this.form = new PusatResolusiV2Detail({
      ...this.form,
      sttNoShipmentNo: item.sttNo
    });

    this.isChangeSttOrShipmentNo = true;
    await this.onCheckStt();
  }
  sttShipmentDetail = new TicketPusatResolusiDetail();
  sttIssueCategory = "";

  async onCheckStt(isCheckButton = false) {
    const invalidStt =
      (!this.isChangeSttOrShipmentNo && !isCheckButton) ||
      !this.form.sttNoShipmentNo;
    if (invalidStt) return;

    const checkTicket = async () => {
      try {
        MainAppController.showLoading();
        this.sttShipmentDetail = await PusatResolusiV2Controller.checkTicket(
          new CheckTicketPusatResolusiRequest({
            refNo: this.form.sttNoShipmentNo
          })
        );
        if (this.isChangeSttOrShipmentNo) {
          this.form = new PusatResolusiV2Detail({
            type: this.form.type,
            sttNoShipmentNo: this.form.sttNoShipmentNo
          });
          this.onResetAllAttachments();
        }

        // hide card last stt or shipment no if stt or shipment is valid
        this.sttOrShipmentNoInLastSttOrShipmentList = true;
      } catch (error) {
        this.onErrorCheckStt(error);
      } finally {
        MainAppController.closeLoading();
        this.isChangeSttOrShipmentNo = false;
      }
    };

    if (isCheckButton) {
      const checkTicketDebounced = _.debounce(checkTicket, 200);
      checkTicketDebounced();
    } else if (this.form.sttNoShipmentNo.length >= 3) {
      await checkTicket();
    } else {
      this.sttShipmentDetail = new TicketPusatResolusiDetail();
    }
  }
  onErrorCheckStt(error: any) {
    const message = error?.response?.data?.message?.id;

    if (message) {
      this.sttShipmentDetail = new TicketPusatResolusiDetail({
        message
      });
      return;
    }

    MainAppController.showErrorMessage(
      parsingErrorResponse(error, "Gagal cek laporan kendala!")
    );
  }

  get sttShipmentInfo() {
    const { success, action } = this.sttShipmentDetail;

    if (!success) {
      return "";
    }

    if (action === PusatResolusiV2Action.VIEW_DETAIL) {
      return "No. STT sudah pernah dilaporkan, lihat detail untuk mengikuti laporan!";
    }

    if (
      action === PusatResolusiV2Action.CS ||
      action === PusatResolusiV2Action.CLAIM
    ) {
      return "Kendala sudah dilaporkan, tapi belum terdaftar di kategori kendala Genesis.";
    }

    return "";
  }
  toDetail(isModal: boolean) {
    this.$router.push(
      `/pusat-resolusi-v2/detail/${
        isModal ? this.ticketDetail.id : this.sttShipmentDetail.id
      }`
    );
  }

  // category
  listCategory: OptionsClass[] = [];
  async getListCategory(open = false) {
    if (open) {
      await this.onCheckStt();
      if (this.sttShipmentInfo || this.sttShipmentDetail.message) return;

      try {
        MainAppController.showLoading();
        this.listCategory = [];
        const { sttNoShipmentNo, type } = this.form;
        const res = await PusatResolusiV2Controller.getListCategory(
          new CheckTicketPusatResolusiRequest({
            refNo:
              !this.sttShipmentInfo && !this.sttShipmentDetail.message
                ? sttNoShipmentNo
                : "",
            type
          })
        );
        this.onSuccessGetListCategory(res);
      } catch (error) {
        MainAppController.showErrorMessage(
          parsingErrorResponse(error, "Gagal mengambil data category!")
        );
      } finally {
        MainAppController.closeLoading();
      }
    }
  }
  onSuccessGetListCategory(res: CategoryPusatResolusi[]) {
    // sort by disabled
    const data = res.map(
      (item) =>
        new OptionsClass({
          name: item.label,
          value: item.code,
          disabled: !item.isEligible,
          meta: {
            ...item
          }
        })
    );
    this.listCategory = data.sort((a, b) => {
      if (a.disabled === b.disabled) return 0;
      if (a.disabled && !b.disabled) return 1;
      return -1;
    });
  }
  onSelectCategory(item: OptionsClass) {
    this.sttIssueCategory = "";
    this.form = new PusatResolusiV2Detail({
      ...this.form,
      description: item.meta?.template || "",
      isDescRequired: !!item.meta?.isDescRequired,
      isAttachmentRequired: !!item.meta?.isAttachmentRequired
    });
  }

  // description
  onDeleteDescription() {
    this.form.description = "";
  }

  // attachment
  onAddFile() {
    this.form.attachments.push(null);
  }
  onResetAllAttachments() {
    this.form.attachments.forEach((_, index) => {
      const file = this.$refs?.[`attachment-${index}`] as any;
      file?.onReset?.();
    });
    // Reset the attachments array to initial state with one null value
    this.form.attachments = [null];
  }

  // pre submit
  get disabled(): boolean {
    const {
      type,
      sttNoShipmentNo,
      category,
      description,
      isDescRequired,
      attachments,
      isAttachmentRequired
    } = this.form;

    return [
      this.sttIssueCategory,
      this.sttShipmentDetail.message, // error stt or shipment no
      this.sttShipmentInfo, // stt already reported
      !type || !category?.value, // type or category not selected
      type === PusatResolusiV2Type.shippingService && !sttNoShipmentNo, // stt or shipment required for shipping service
      isDescRequired && !description, // description required based on category
      isAttachmentRequired && attachments?.some((a) => !a) // attachment required based on category
    ].some((a) => a);
  }
  onConfirmCreate() {
    MainAppController.showMessageModal(
      new ModalMessageEntities({
        image: "badge-confirmation-general",
        title: "Laporan kendala sudah sesuai?",
        message:
          "Pastikan detail yang Anda kirim sesuai karena hanya bisa melaporkan 1 kendala untuk 1 STT.",
        onSubmit: this.onCreate,
        onClose: () => {
          MainAppController.closeMessageModal();
        },
        textSuccess: "Ya, sesuai",
        textCancel: "Batal",
        customWidth: "417px",
        customButton: "w-full",
        customParentButton: "w-full",
        customWrapperButton: "w-full px-6"
      })
    );
  }

  // submit
  showResponseCreate = false;
  ticketDetail = new TicketPusatResolusiDetail();
  async onCreate() {
    try {
      MainAppController.showLoading();
      MainAppController.closeMessageModal();

      this.ticketDetail = await PusatResolusiV2Controller.create(
        new CheckTicketPusatResolusiRequest({
          categoryCode: this.form.category?.value,
          refNo: this.form.sttNoShipmentNo,
          desc: this.form.description,
          attachments: this.form.attachments.filter(
            (e): e is File => e !== null
          )
        })
      );
      this.showResponseCreate = true;
    } catch (error) {
      const data: any = (error as any)?.response?.data;

      if (!(error as any).response) {
        MainAppController.showErrorMessage(
          new ErrorMessageEntities({
            type: INTERNET_ERROR,
            title: "Jaringan internet terputus",
            message: 'Periksa jaringan internal Anda lalu klik "Muat ulang".',
            onClose: () => this.onCreate(),
            buttonSuccessText: "Muat ulang"
          })
        );
        MainAppController.setErrorMessageEntities({
          ...MainAppController.errorMessageEntities,
          title: "Jaringan internet terputus",
          message: 'Periksa jaringan internal Anda lalu klik "Muat ulang".'
        });
        return;
      }
      if (
        !PusatResolusiV2CodeResponseCreate[
          data?.code as keyof typeof PusatResolusiV2CodeResponseCreate
        ]
      ) {
        MainAppController.showErrorMessage(
          parsingErrorResponse(error, "Gagal membuat laporan kendala!")
        );
        return;
      }

      this.onFailedCreate(data);
    } finally {
      MainAppController.closeLoading();
    }
  }
  onFailedCreate(data: any) {
    const { code, ticket, stt, shipment } = data;

    // for code 101 and 102
    if (ticket) {
      this.ticketDetail = new TicketPusatResolusiDetail({
        id: ticket.id,
        ticketNo: ticket.ticket_no,
        caseNumber: ticket.case_number,
        refNo: ticket.ref_no,
        categoryCode: ticket.category_code,
        categoryName: ticket.category.label,
        desc: ticket.desc,
        status: ticket.status,
        shipmentId: shipment.shipment_id,
        shipmentLastStatus: shipment.last_status,
        sttNo: stt.stt_no,
        sttLastStatus: stt.last_status,
        action: ticket.category?.action,
        code
      });
    } else {
      // for code 103
      this.ticketDetail = new TicketPusatResolusiDetail({
        shipmentId: shipment.shipment_id,
        shipmentLastStatus: shipment.last_status,
        sttNo: stt.stt_no,
        sttLastStatus: stt.last_status,
        code
      });
    }
    this.showResponseCreate = true;
  }
  get responseCreateData(): ModalMessageEntities {
    const onClose = () => {
      this.showResponseCreate = false;
      this.ticketDetail = new TicketPusatResolusiDetail();
    };
    const data = new ModalMessageEntities({
      title: this.ticketDetail.success
        ? "Kendala berhasil dilaporkan!"
        : "Kendala gagal dilaporkan",
      image: this.ticketDetail.success
        ? "Ill_Badge_Action-Success"
        : "stop-program",
      onSubmit: () => this.onBack(true),
      onClose
    });

    if (this.ticketDetail.code === PusatResolusiV2CodeResponseCreate["101"]) {
      return new ModalMessageEntities({
        ...data,
        message: "Pernah dilaporkan dengan kendala berikut:",
        textSuccess: "Lihat detail",
        onSubmit: () => this.toDetail(true),
        textCancel: "Kembali"
      });
    }

    if (this.ticketDetail.code === PusatResolusiV2CodeResponseCreate["102"]) {
      return new ModalMessageEntities({
        ...data,
        title:
          "Kendala sudah dilaporkan,<br />tapi belum terdaftar di kategori kendala Genesis.",
        message: ""
      });
    }

    if (this.ticketDetail.code === PusatResolusiV2CodeResponseCreate["103"]) {
      return new ModalMessageEntities({
        ...data,
        message: "Status terakhir STT kendala ini sudah tidak memenuhi syarat.",
        textSuccess: "Cek kembali",
        onSubmit: () => {
          onClose();
          this.sttIssueCategory =
            "Kategori kendala tidak sesuai panduan laporan status terakhir.";
        }
      });
    }

    if (this.ticketDetail.code === PusatResolusiV2CodeResponseCreate["104"]) {
      return new ModalMessageEntities({
        ...data,
        title: "Kendala sudah dilaporkan, sebelum pusat resolusi terbaru.",
        message: ""
      });
    }

    return new ModalMessageEntities({
      ...data,
      message: "Tim akan memproses kendala Anda.",
      textSuccess: "Oke, mengerti"
    });
  }
  get showCsInfoCreateResponse() {
    const codeType =
      this.ticketDetail.code === PusatResolusiV2CodeResponseCreate[102] ||
      this.ticketDetail.code === PusatResolusiV2CodeResponseCreate[104];

    return codeType && !this.ticketDetail.success;
  }
  get pusatResolusiV2CodeResponseCreate() {
    return PusatResolusiV2CodeResponseCreate;
  }

  onDeleteAttachment(index: number) {
    this.form.attachments.splice(index, 1);
  }
}
